
import { defineComponent, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { EmployeeRouteNames } from '@/router/routes-names'
import EmployeesEditForm from '@/components/employees/forms/edit.vue'
import EmployeesAssignPasswordForm from '@/components/employees/forms/assign-password.vue'
import { useEmployeeModule } from '@/modules/employees'

export default defineComponent({
    name: 'view-employees-edit-employee',
    components: {
        EmployeesAssignPasswordForm,
        EmployeesEditForm
    },
    async setup () {
        const $q = useQuasar()
        const { getSingleEmployee, loadAvailableRoles } = useEmployeeModule()
        const router = useRouter()
        const route = useRoute()
        const id = route.params.id as string

        loadAvailableRoles()
        try {
            const employeeModel = await getSingleEmployee(id)

            const { isBlocked, ...employee } = employeeModel
            const employeeFormModel = {
                ...employee,
                roles: employee.roles.map(role => role.key)
            }

            return {
                employeeModel,
                employeeFormModel,
                tab: ref('edit'),
                splitterModel: ref(20)
            }
        } catch (err) {
            $q.notify({
                color: 'negative',
                message: `we couldn't find employee with id ${id}`
            })
            await router.push({ name: EmployeeRouteNames.LIST, query: { page: route.query.page } })
        }
    }
})
